import { createI18n } from 'vue-i18n'
import es from './es'
import en from './en'

export type MessageSchema = typeof es

export const i18n = createI18n<[MessageSchema], 'es' | 'en'>({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  messages: {
    es,
    en,
  },
})

export default i18n
